import React from "react";
import axios from "axios";
import { useState, useEffect, useContext, createContext } from "react";
export const MovieDetailsContext = createContext();
const MovieDetailsContextProvider = (props) => {
  const [info, setInfo] = useState({});
  const [Loading, setLoading] = useState(false);
  const[recommendation, setRecommendation] = useState([])
  const[uKey , setKey]= useState("")
  const [Ratings, setRatings] = useState("0")
  const [imdb , setIMDB] = useState("")
  const apiKey = process.env.REACT_APP_API_KEY
  const fetchDetailInfo = async (movieId) => {
    try {
        setLoading(true)
      const url =
        `https://api.themoviedb.org/3/movie/${movieId}?api_key=${apiKey}&language=en-US`;
      const getData = await axios.get(url);
      console.log(getData);
      setInfo(getData.data)
      console.log(getData.data)
      const recc = await getRecommendation(movieId)
      console.log(recc.data.results)
      setRecommendation(recc.data.results)
      setRatings(recc.data.results[0].vote_average)
      const video = await getVideos(movieId)
      const imd = await getImdb(movieId)
      console.log(video.data.results[0].key)
      setKey(video.data.results[0].key)
    
      setLoading(false)
    } catch (err) {
      console.log(err);
    }
  };
  const getRecommendation= async(movieId)=>{
    const Rurl= `https://api.themoviedb.org/3/movie/${movieId}/recommendations?api_key=${apiKey}`
    const res = await axios.get(Rurl);
    console.log("recommendation")
    console.log(res)
    return(res)

  }
  const getVideos= async(movieId)=>{
    const Rurl= `https://api.themoviedb.org/3/movie/${movieId}/videos?api_key=${apiKey}`
    const res = await axios.get(Rurl);
    console.log("videos")
    console.log(res)
    return(res)

  }
  const getImdb = async(movieId)=>{
    const IMDBid = await axios.get(`https://api.themoviedb.org/3/movie/${movieId}?api_key=${apiKey}`)
    console.log("imdb ")
    console.log(IMDBid.data.imdb_id)
    const Id = IMDBid.data.imdb_id
    console.log(Id)
    const res = await axios.get(`https://api.themoviedb.org/3/find/${Id}?api_key=${apiKey}&external_source=imdb_id`)
    console.log("imdb res")
    console.log(res)
    setIMDB(res.data.movie_results[0].vote_average)
 
  }
  
  return (
    <div>
      <MovieDetailsContext.Provider value={{ fetchDetailInfo, info,Loading , getRecommendation, imdb, recommendation, uKey, Ratings}}>
        {props.children}
      </MovieDetailsContext.Provider>
    </div>
  );
};
export default MovieDetailsContextProvider;
